import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { AuthService } from "../auth/services/auth.service";
import { routes } from "../../../environments/environment.routes";
import { DialogService } from "primeng/dynamicdialog";
import { CUSTOM_AUTH_TOKEN } from "../../shared/services/http-products.service";
import {
  ALERT_HISTORY_AUTH,
  AlertHistorySessionService,
} from "../../features/alerts/services/alert-history-session.service";

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);
  private alertHistorySession = inject(AlertHistorySessionService);
  private dialogService = inject(DialogService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Check if there's a custom auth token in HttpContext (for getProductByUpc endpoint)
    const customToken = req.context.get(CUSTOM_AUTH_TOKEN);

    if (customToken) {
      // Use the custom token from URL params instead of the session token
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${customToken}` },
      });
    } else {
      // Use the normal authorization logic
      const userSession = this.auth.userSession.value;
      const accessToken = userSession?.token?.access_token;

      if (accessToken && !PUBLIC_ROUTES.includes(req.url)) {
        req = req.clone({
          setHeaders: { Authorization: `Bearer ${accessToken}` },
        });
      }
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Close all open dialogs
          this.dialogService.dialogComponentRefMap.forEach((dialog) => {
            dialog.destroy();
          });

          if (req.context.get(ALERT_HISTORY_AUTH)) {
            // Alert History token expired or invalid: clear the stored entry
            // data and leave to the logout_url (TWX-536)
            this.alertHistorySession.endSession();
          } else {
            // Logout user
            this.auth.clearSession();
          }
        }
        return throwError(() => error);
      }),
    );
  }
}

const PUBLIC_ROUTES = [routes.api.auth.login, routes.api.auth.verifyEmail];
